import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  font-family: ${(props) => props.theme.font.typeface.secondary};
`;

const DatePickerInput = React.forwardRef<HTMLInputElement>((props, ref) => {
  return <StyledInput ref={ref} {...props} aria-label="Date" data-cy="customDateInput" />;
});

export default DatePickerInput;
